// Static site copy. Partner + calculator data comes from the backend.
export const SITE = {
  name: "Health and More",
  domain: "healthandmore.net",
  tagline: "We connect independent practices to hospital-system programs.",
};

export const NAV = [
  { to: "/340b", label: "340B" },
  { to: "/rpm", label: "RPM" },
  { to: "/mso", label: "MSO" },
  { to: "/network", label: "Network" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/about", label: "About" },
];

export const RPM_SPECIALTIES = [
  "Internal medicine",
  "Family practice",
  "Cardiology",
  "Endocrinology",
  "Nephrology",
];

export const B340_SPECIALTIES = [
  "Hematology",
  "Hematology-oncology",
  "Medical oncology",
  "Nephrology",
  "Pulmonary disease",
  "Rheumatology",
];

export const CPT_CODES = [
  {
    code: "99453",
    title: "Setup and patient education",
    requirement: "One-time. Covers device setup and teaching the patient to use it.",
  },
  {
    code: "99454",
    title: "Device supply and transmission",
    requirement: "Requires at least 16 days of readings in a 30-day period. No 16 days, no bill.",
  },
  {
    code: "99457",
    title: "First 20 minutes of management",
    requirement: "Requires interactive communication with the patient during the month.",
  },
  {
    code: "99458",
    title: "Each additional 20 minutes",
    requirement: "Billed per additional 20 minutes of management time, documented.",
  },
];

export const HOW_STEPS = [
  {
    week: "Weeks 1–2",
    title: "Fit and affiliation",
    practice: "You share your specialty, panel size, and drug spend. We confirm which covered entity fits.",
    us: "We check market coverage and start the affiliation paperwork with the hospital partner.",
  },
  {
    week: "Weeks 3–6",
    title: "Credentialing and setup",
    practice: "You sign agreements and give us the documents credentialing needs. Nothing changes clinically yet.",
    us: "We handle credentialing, payer enrollment, device logistics or 340B split-billing setup, and staff training.",
  },
  {
    week: "Weeks 7–10",
    title: "Go live",
    practice: "You start prescribing or enrolling patients exactly as you do now.",
    us: "We run enrollment, documentation, transmissions or dispensing, and the audit file from day one.",
  },
  {
    week: "Weeks 10–16",
    title: "First revenue",
    practice: "You keep seeing patients.",
    us: "First billing cycles clear. Revenue is realistic, not immediate — most programs show meaningful numbers by month three to four.",
  },
];

export const BANNED_NOTE =
  "We collect practice-level business information only. Never patient data.";

// Network / partner experience — framed as our hospital partners + operating team, not our own client count.
export const PROOF = [
  { value: "5", label: "Partner hospitals in network", note: "Four in Pennsylvania, one in Chicago" },
  { value: "700+", label: "Physicians & providers supported", note: "Across the partner hospital systems" },
  { value: "10", label: "Specialties covered", note: "340B and RPM programs combined" },
  { value: "Decades", label: "Combined team experience", note: "Pharmacy operations, revenue cycle, and benefits" },
];

// Per-service Open Graph share cards (branded).
export const OG = {
  default: "https://static.prod-images.emergentagent.com/jobs/c09ab08a-99d7-414d-84f0-5423f34f5ca5/images/8e16489f58cc4bb2010f1747b7da0b8551f944d8644656698da6818127b49b5b.jpeg",
  b340: "https://static.prod-images.emergentagent.com/jobs/c09ab08a-99d7-414d-84f0-5423f34f5ca5/images/9aff850bbbd00e5a2ad6e928a14a0afd3040aaf6d7d59d50577f64cf8dd61123.jpeg",
  rpm: "https://static.prod-images.emergentagent.com/jobs/c09ab08a-99d7-414d-84f0-5423f34f5ca5/images/c4e4f7a292d682cd753dea8a82cc709c0b6a3bbff55ba1cc5fb7132b26cf648a.jpeg",
  mso: "https://static.prod-images.emergentagent.com/jobs/c09ab08a-99d7-414d-84f0-5423f34f5ca5/images/1bce453f52ebce4c895fc6a06ee019250e3d9a01203a81ea9d9ed2b752a1b027.jpeg",
  network: "https://static.prod-images.emergentagent.com/jobs/c09ab08a-99d7-414d-84f0-5423f34f5ca5/images/e931cf6c10886090448b1fdce3891a87af30f504fb027301d61a44213cabd6a2.jpeg",
};

// Markets we currently serve, keyed by US state code.
export const SERVED_STATES = ["PA", "IL"];

export const US_STATES = [
  ["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"],
  ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["FL", "Florida"], ["GA", "Georgia"],
  ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"],
  ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"],
  ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"],
  ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"],
  ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"],
  ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"],
  ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"],
  ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"],
  ["DC", "Washington, D.C."],
];
